export default defineNuxtPlugin({
  name: 'daktela',
  setup() {
    if (import.meta.server) {
      return;
    }

    const {
      public: {
        daktela: { accessToken },
      },
    } = useRuntimeConfig();

    if (!accessToken || accessToken.length === 0) {
      return;
    }

    const daktelaConfig = {
      server: 'https://portu.daktela.com/',
      accessToken,
    };

    const daktelaScriptEl = document.createElement('script');
    daktelaScriptEl.type = 'text/javascript';
    daktelaScriptEl.async = true;
    daktelaScriptEl.src = `${daktelaConfig.server}external/web/web.js?origin=${encodeURIComponent(location.origin)}`;
    daktelaScriptEl.onload = () => {
      if (typeof window.daktelaGui === 'undefined' || !window.daktelaGui) {
        return;
      }

      window.daktelaWeb = new window.daktelaGui();
      window.daktelaWeb.init(daktelaConfig);
    };

    const head = document.getElementsByTagName('head')[0];
    if (head !== undefined) {
      head.appendChild(daktelaScriptEl);
    }

    useRuntimeHook('user-authenticated', (email: string) => {
      let retryCount = 0;
      const interval = setInterval(() => {
        if (typeof window.daktelaWeb === 'undefined' || !window.daktelaWeb) {
          if (retryCount > 10) {
            window.clearInterval(interval);
            return;
          }

          retryCount++;

          return;
        }

        window.daktelaWeb.init({
          ...daktelaConfig,
          settings: {
            inputs: {
              email: { defaultValue: email },
            },
          },
        });

        window.clearInterval(interval);
      }, 1000);
    });
  },
});
